// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"8b704ab5","652":"829cc722","922":"cc2b1d87"}[chunkId] + ".chunk.css";
};